import { render, staticRenderFns } from "./CompareEmptyComponent.vue?vue&type=template&id=3a12fffc"
import script from "./CompareEmptyComponent.vue?vue&type=script&lang=js"
export * from "./CompareEmptyComponent.vue?vue&type=script&lang=js"
import style0 from "./CompareEmptyComponent.vue?vue&type=style&index=0&id=3a12fffc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports